const normalize = (value) => String(value || "").trim().toLowerCase().replace(/[\s-]+/g, "_");

export function activityTypeCategory(activity = {}) {
  const metadata = activity.metadata || {};
  const type = normalize(activity.activity_type || activity.activityType);
  const kinds = [type, metadata.activity_type, metadata.workflow_kind, metadata.review_kind].map(normalize);
  if (kinds.some(kind => ["scheduling", "interview_schedule", "interview", "meeting", "discovery_call"].includes(kind)) || metadata.calendar_event_id) return "Scheduling";
  if (kinds.some(kind => ["candidate_match", "job_candidate_match", "candidate_matching"].includes(kind))) return "Candidate Match";
  if (kinds.includes("approval") || metadata.review_kind || metadata.review_status) return "Approval";
  if (kinds.some(kind => ["recruiting_sequence", "sequence", "sequence_enrollment"].includes(kind)) || metadata.sequence_id || metadata.sequence_name) return "Recruiting Sequence";
  if (["email", "mail"].includes(type)) return "Email";
  if (["note", "comment"].includes(type)) return "Note";
  return "Action";
}

export function activityPriorityCategory(activity = {}) {
  const priority = activity.metadata?.priority ?? activity.priority;
  const value = normalize(priority && typeof priority === "object" ? priority.label || priority.value : priority);
  return ({ critical: "Critical", urgent: "Critical", high: "High", medium: "Medium", normal: "Medium", low: "Low" })[value] || "Unspecified";
}
